module.exports = __webpack_public_path__ + "static/media/Box.0ed26bb4.jpg";